import {KIJS, apiServiceHost}  from "../config";
/*
*	API calss used for KIJS api services
* 	Example: api('search').get({q:'brīvības iela'}, callback);
*/
var api = function(optionsIn){
	
	if(!(this instanceof api)){
		return new api(optionsIn);
	}
	
	//add new api urls here
	this.apis_ = {
		"search":"kijs/v3/" + KIJS + "/api/search",
		"revGeo":"kijs/v3/" + KIJS + "/api/reverse_geocoding",
		"getgeometry":"kijs/server_scripts/get_geometry.php?kijs=" + KIJS + "&proj=4326", //hash=83f1bae0574fe8a41e0880dc6e50e2b4
		"traffic":"kijs/v3/" + KIJS + "/api/trafficjam",
		"speedcameras":"kijs/v3/" + KIJS + "/api/speedcameras",
		//"routingGDH":"routing/route/v1/driving/",
	};
	
	var options = {};
	
	if(typeof optionsIn === 'string'){
		options.api = optionsIn;
	}else if(typeof optionsIn === 'object'){
		options = _.extend(options, optionsIn);
	}
		
	this.activeURL = this.setUrl_(options.api);
	
	return this;
};

api.prototype.setUrl_ = function(strApi){
	
	if(typeof this.apis_[strApi] != 'undefined') {
		const apiHost = strApi === 'routingGDH' ? gdhServiceHost : apiServiceHost;
		
		return apiHost + "/" + this.apis_[strApi];
	} else {
		console.log('Unknown api service');
	}
	
};

api.prototype.setUrlVals_ = function(strApi, objValues){
	
	var strURL = strApi;
	
	var n = 0;
	for(var key in objValues){
		if( objValues.hasOwnProperty( key ) ) {
			
			if(n === 0 && strURL.indexOf("?") === -1){
				strURL += "?";
			}else{
				strURL += "&";
			}
			
			strURL += key + "=" + objValues[key];
			
			n++;
		}
	}
	
	return strURL;
};

api.prototype.remove = function(objKeyVals, callback){
	//wip
};

api.prototype.put = function(objKeyVals, callback){
	//wip
};

api.prototype.post = function(objKeyVals, callback){
	//wip
};

api.prototype.get = function(objKeyVals, callback){
	fetch( this.setUrlVals_(this.activeURL, objKeyVals))
		.then(response => response.json())
		.then(data => callback( data ));
/*	$.ajax({
	  url: this.setUrlVals_(this.activeURL, objKeyVals),
	  context: document.body,
	  dataType: 'json',
	  contentType: 'multipart/form-data'
	}).done(function(data) {
	  
		if(typeof callback === 'function'){
			callback(data);
		}
	});*/
};

export default api;


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/api/index.js